import styled from 'styled-components';
import rtl from 'styled-components-rtl';
import { toRem, theme } from '@marriott/mi-ui-library-shop';
import { baseVariables } from '@marriott/mi-ui-library';

export const StyledFilterComponentDiv = styled.div`
  ${rtl`
  margin: auto;
  @media only ${theme.mediaQuery.allMobiles}{
    margin-left: auto;
    margin-right:auto;
  }
  font-family: ${theme.fonts['fontFamilySwiss']};
  font-weight: ${theme.fonts['fontWeightMedium']};
  line-height: ${toRem(24)};
  margin-bottom: ${toRem(16)};

  &.filter-chat-view {
  width: 100%;
  max-width: 100%;
    @media only ${baseVariables.mediaQuery.lg} {
      justify-content: flex-end;
      .row-1 {
        padding-top: 0 !important;
      }
    }


  }

  .row-1 {
    /* mobile-first: scrollable */
    display: block;
    overflow-x: auto;
    overflow-y: visible;

    @media only ${baseVariables.mediaQuery.md} {
      /* tablet and up: align items inline */
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: ${toRem(8)};
      margin-left: 0;
    }

  }
  .row-1::-webkit-scrollbar {
    display: none;
  }
  .filter-option-button.active {
    background-color: ${theme.color['close-silver']};
  }

  .row-1-container {
    display: flex;
    align-items: center;
    width: max-content;
  }
  .quick-filter-container {
    @media ${baseVariables.mediaQuery.md} {
      width: max-content;
    }
    @media ${baseVariables.mediaQuery.lg} {
      width: auto;
    }
  }
  .quick-filter-container-chat {
    overflow-x: auto;
    width: max-content;
  }
  .map-1-container{
    @media only ${theme.mediaQuery.largerMobile}{
    padding-left: ${toRem(8)};
    }
  }

  /* Override shared Tabs padding for FiltersComponent usage only */
  .filters-tab-no-padding {
    width: ${toRem(212)};
    height: ${toRem(46)};
    border-radius: ${toRem(99)};
    box-shadow: none;

    .m-switcher-tab-list {
      display: flex;
      width: ${toRem(212)};
      height: ${toRem(46)};
      gap: 0;
      padding: 0 ${toRem(4)};
      align-items: center;
      border-radius: ${toRem(99)};
      background: ${baseVariables.color.neutral20};
    }

    .m-switcher-tab-list-item {
      width: ${toRem(102)};
      height: ${toRem(38)};
      border-radius: ${toRem(99)} !important;
      display: flex;
      align-items: center;
      justify-content: center;
      overflow: hidden;
      padding: 0;

      &:focus,
      &.active {
        border-radius: ${toRem(99)} !important;
      }

      .icon {
        width: ${toRem(18)};
        height: ${toRem(18)};
        font-size: ${baseVariables.font.fontL};
        line-height: ${baseVariables.font.lineHeightS};
        display: inline-flex;
        align-items: center;
        justify-content: center;
        margin-right: ${toRem(6)};
        color: ${baseVariables.color.base10};
      }

      /* Headings rendered as span with class t-font-xs in switcher tabs */
      .switcher-tab-heading {
        line-height: ${baseVariables.font.lineHeightS};
        font-weight: ${baseVariables.font.fontWeightMedium};
        color: ${baseVariables.color.base10};
      }
    }

    .m-switcher-tab-list-item button,
    .m-switcher-tab-list-item a {
      width: 100%;
      height: 100%;
      border-radius: ${toRem(99)} !important;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 0;
    }
  }

  .filter-option-button {
    margin: ${toRem(0)} ${toRem(8)} ${toRem(0)} ${toRem(0)};
    box-sizing: border-box;
    border: ${toRem(1)} solid ${theme.color['close-silver']};
    border-radius: ${toRem(8)};
    background-color: ${theme.color['white']};
    padding: ${toRem(8)} ${toRem(12)};
    width: max-content;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    align-content: center;
    flex-direction: row;
    height: 38px;

    @media only ${theme.mediaQuery.allMobiles} {
      margin-right: ${toRem(4)};
    }

    &:hover {
      color: ${theme.color['cod-grey']};
      font-weight: ${theme.fonts['fontWeightRegular']};
    }
    &:focus {
      border: ${toRem(1)} solid ${theme.color['black']} !important;
      color: ${theme.color['cod-grey']};
      font-weight: ${theme.fonts['fontWeightRegular']};
    }
  }

  .filter-divider {
    box-sizing: border-box;
    height: ${toRem(38)};
    width: ${toRem(1)};
    border-left: ${toRem(1)} dashed ${theme.color['close-silver']};
    margin: 0 ${toRem(8)};
  }

  .icon-check {
    margin: 0 ${toRem(2)};
  }
  `}
`;
